<div class="backdrop d-flex-cc">
  <div class="modal-dialog">
    <div class="info-container">
      <div class="row-0 d-flex-cc">
        <img class="logo" alt="logo" [src]="imagenLogo" width="100%" height="100%" />
      </div>

      <ng-container *ngIf="step === 'info'">
        <div class="row-1">
          <h3>{{ siteName }} solicita tu consentimiento para usar datos personales con los siguientes objetivos:</h3>
          <div class="permission">
            <div class="icon-wrapper"><mat-icon class="">person_outline</mat-icon></div>
            <p>Publicidad y contenido personalizados, medición de publicidad y contenido, investigación de audiencia y desarrollo de servicios.</p>
          </div>
          <div class="permission">
            <div class="icon-wrapper"><mat-icon class="">devices</mat-icon></div>
            <p>Almacenar información en un dispositivo y/o acceder a ella.</p>
          </div>

          <div class="row-header">
            <div class="rowPermiso"></div>
            <p>Para ofrecer las mejores experiencias, utilizamos tecnologías como las cookies para almacenar y/o acceder a la información del dispositivo. El consentimiento de estas tecnologías nos permitirá procesar datos como el comportamiento de navegación o las identificaciones únicas en este sitio. No consentir o retirar el consentimiento, puede afectar negativamente a ciertas características y funciones.</p>
            <p>Tus datos personales se tratarán y la información de tu dispositivo (cookies, identificadores únicos y otros datos del dispositivo) podrá ser almacenada, consultada y compartida con nuestros proveedores aprobados por el TCF y los partners publicitarios o utilizada específicamente por este sitio o aplicación.</p>
            <p>Es posible que algunos proveedores traten tus datos personales en virtud de un interés legítimo, algo a lo que puedes oponerte gestionando tus opciones a continuación. Busca un enlace al final de esta página o en nuestra política de privacidad para revocar el consentimiento. Puedes ver nuestra política de cookies en <a href="/politica-cookies" target="_blank">este enlace.</a></p>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="step === 'config'">
        <div class="modal-container">
          <div class="modal-type" (click)="toggleDropdown(0)">
            <div class="modal-header" style="flex-direction: row">
              <h3>Cookies necesarias</h3>
              <mat-slide-toggle color="primary" unchecked disabled></mat-slide-toggle>
            </div>
            <div class="dropdown-wrapper" [ngClass]="dropdownState === 0 ? 'dropdown' : ''">
              <p class="inner">
                Son esenciales para el funcionamiento básico de un sitio web. Son fundamentales para proporcionar los servicios solicitados por los usuarios y no se utilizan para recopilar información personal para fines de marketing.<br /><br />
                Dado su carácter esencial, estas cookies se activan automáticamente y no requieren el consentimiento del usuario según la normativa vigente sobre privacidad en línea.
              </p>
            </div>
          </div>
          <div class="modal-type" (click)="toggleDropdown(1)">
            <div class="modal-header" style="flex-direction: row">
              <h3>Cookies de rendimiento</h3>
              <mat-slide-toggle #slideRendimiento [checked]="rendimientoValue" enabled color="primary" (click)="$event.stopPropagation()"></mat-slide-toggle>
            </div>
            <div class="dropdown-wrapper" [ngClass]="dropdownState === 1 ? 'dropdown' : ''">
              <p class="inner">
                Las cookies de rendimiento recopilan información sobre cómo utilizas nuestro sitio web. Nos ayudan a entender qué páginas son las más populares, cuánto tiempo pasan los visitantes en ellas, y cómo navegan los usuarios a través del sitio.<br />
                <br />
                Esta información es vital para mejorar la experiencia del usuario. No recopilan información que identifique directamente a los usuarios.
              </p>
            </div>
          </div>
          <!-- <div class="cookie-type"  (click)="toggleDropdown(2)">
                        <div class="cookie-header" style="flex-direction: row;">
                            <h3>Cookies funcionales</h3>
                            <mat-slide-toggle checked enabled color="primary" (click)="$event.stopPropagation()"></mat-slide-toggle>
                        </div>
                        <div class="dropdown-wrapper" [ngClass]="dropdownState === 2 ? 'dropdown' : ''">
                            <p class="inner">Las cookies funcionales son utilizadas para recordar tus preferencias y elecciones en nuestro sitio web. Estas cookies permiten una experiencia más personalizada y eficiente. Son esenciales para proporcionar características específicas y mejorar la usabilidad del sitio.</p>
                        </div>
                    </div> -->
          <div class="modal-type" (click)="toggleDropdown(3)">
            <div class="modal-header" style="flex-direction: row">
              <h3>Cookies de publicidad</h3>
              <mat-slide-toggle #slidePublicidad [checked]="publicidadValue" enabled color="primary" (click)="$event.stopPropagation()"></mat-slide-toggle>
            </div>
            <div class="dropdown-wrapper" [ngClass]="dropdownState === 3 ? 'dropdown' : ''">
              <p class="inner">Las cookies de publicidad se utilizan para mostrarte anuncios personalizados. Recopilan información sobre tus hábitos de navegación y se utilizan para identificar tus intereses, permitiéndonos mostrar anuncios personalizados en otros sitios web. Estas cookies también ayudan a medir la efectividad de las campañas publicitarias.</p>
            </div>
          </div>
        </div>
      </ng-container>
      <div class="row-2">
        <ng-container *ngIf="step === 'info'">
          <div class="buttons-div d-flex-cc">
            <button mat-flat-button class="h-button" (click)="goConfig()">Configurar</button>
            <button mat-flat-button class="h-button" (click)="onAccept()">Aceptar</button>
          </div>
          <button mat-flat-button class="h-button" (click)="onReject()">Rechazar</button>
        </ng-container>
        <ng-container *ngIf="step === 'config'">
          <button mat-flat-button type="button" class="h-button" (click)="onAcceptConfig()">Aceptar</button>
          <button mat-flat-button class="h-button" (click)="onReject()">Rechazar</button>
        </ng-container>
      </div>
    </div>
  </div>
</div>
